var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9967 12.0095C22.9967 6.4871 18.5148 2.00513 12.9923 2.00513C7.46989 2.00513 2.98792 6.4871 2.98792 12.0095C2.98792 16.8517 6.42943 20.8834 10.9914 21.8139V15.0109H8.99056V12.0095H10.9914V9.50843C10.9914 7.57758 12.5621 6.00689 14.493 6.00689H16.9941V9.00821H14.9932C14.443 9.00821 13.9928 9.45841 13.9928 10.0087V12.0095H16.9941V15.0109H13.9928V21.9639C19.045 21.4637 22.9967 17.2018 22.9967 12.0095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.4ff5d72c51656e7a3350a7f06b5731a7.svg";
export { ForwardRef as ReactComponent };